import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem, Button, TextField } from '@mui/material';

const VenueSearchForm = ({
  venueId,
  state,
  icpisManager,
  setVenueId,
  setState,
  states,
  handleSearch,
  handleReset,
  icpisManagers = [],
  handleUpload,
  handleFileChange,
  selectedFile,
  setIcpisManager,
  userRole,
  city,
  setCity,
  venueStatus,
  setVenueStatus,
}) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearch(1);
    }
  };

  return (
  <Box
    display="flex"
    alignItems="center"
    flexWrap="wrap"
    mb={3}
    sx={{ gap: 1, rowGap: 1.5 }}
  >
    {/* <FormControl variant="outlined" sx={{ minWidth: 200, mr: 2 }}>
      <InputLabel>Time Zone</InputLabel>
      <Select
        value={timeZone}
        onChange={(e) => setTimeZone(e.target.value)}
        label="Time Zone"
      >
        <MenuItem value=""><em>Please Select</em></MenuItem>
        <MenuItem value="PST">PST</MenuItem>
        <MenuItem value="CST">CST</MenuItem>
        <MenuItem value="MST">MST</MenuItem>
        <MenuItem value="EST">EST</MenuItem>
      </Select>
    </FormControl> */}
    <FormControl variant="outlined" sx={{ minWidth: 120, maxWidth: 140, flexShrink: 0 }}>
      <InputLabel>State</InputLabel>
      <Select value={state} onChange={(e) => setState(e.target.value)} label="State">
        <MenuItem value=""><em>Please Select</em></MenuItem>
        {states.map((st) => (
          <MenuItem key={st} value={st}>{st}</MenuItem>
        ))}
      </Select>
    </FormControl>
    <TextField
      variant="outlined"
      label="City"
      value={city}
      onChange={(e) => setCity(e.target.value)}
      onKeyDown={handleKeyDown}
      sx={{
        minWidth: { xs: 200, sm: 280 },
        flex: "1 1 280px",
        maxWidth: { xs: "100%", sm: 520 },
      }}
    />
       {userRole === 'ROLE_ICPIE' && (
      <FormControl variant="outlined" sx={{ minWidth: 200 }}>
        <InputLabel>ICPIS Manager</InputLabel>
        <Select value={icpisManager} onChange={(e) => setIcpisManager(e.target.value)} label="ICPIS Manager">
          <MenuItem value=""><em>Please Select</em></MenuItem>
          {icpisManagers.map((manager) => (
            <MenuItem key={manager} value={manager}>{manager}</MenuItem>
          ))}
        </Select>
      </FormControl>
    )}
    <TextField
      variant="outlined"
      label="venueId"
      value={venueId}
      onChange={(e) => setVenueId(e.target.value)}
      onKeyDown={handleKeyDown}
      sx={{ minWidth: 50 }}
    />
      <FormControl variant="outlined" sx={{ minWidth: 200 }}>
      <InputLabel>VenueStatus</InputLabel> 
      <Select
        value={venueStatus}
        onChange={(e) => setVenueStatus(e.target.value)}
        label="VenueStatus"
      >
        <MenuItem value=""><em>Please Select</em></MenuItem>
        <MenuItem value="NORMAL">Normal</MenuItem>
          <MenuItem value="INSTRUCTORISSUE">Instructor Issue</MenuItem>
          <MenuItem value="VENUEISSUE">Venue Issue</MenuItem>
          <MenuItem value="CLOSED">Closed</MenuItem>
          <MenuItem value="INVESTIGATION">Investigation</MenuItem>
      </Select>
    </FormControl>
    <Button variant="contained" color="primary" onClick={() => handleSearch(1)}>
      Search
    </Button>
    <Button variant="outlined" onClick={handleReset} sx={{ mr: 15 }}>
      Reset
    </Button>
    <input
      accept=".xlsx, .xls"
      type="file"
      onChange={(e)=>{handleFileChange(e);
          handleUpload();
      }}
      style={{ display: 'none' }}
      id="upload-file"
    />
    {/* <label htmlFor="upload-file">
      <Button variant="outlined" component="span" sx={{ mr: 2 }}>
        Upload
      </Button>
    </label>

    <Button variant="outlined" onClick={handleExport}>
      Export
    </Button> */}
  </Box>
)};

export default VenueSearchForm;